import { OrderStateStatus } from '../constants';
import { OrderLine } from '../models';

export abstract class OrderLineActionsVisibility {
  public abstract orderLine: OrderLine;
  public abstract isGetInvoiceFeatureEnabled: boolean;

  public get isAllowedCancelProduct(): boolean {
    const allowedStatuses = [OrderStateStatus.PLACED, OrderStateStatus.PAID];

    return allowedStatuses.includes(this.orderLine.status.value);
  }

  public get isAllowedOpenReturnInstructions(): boolean {
    return [OrderStateStatus.RETURN_REQUESTED, OrderStateStatus.RETURN_ACCEPTED].includes(this.orderLine.status.value);
  }

  public get isAllowedReturnProduct(): boolean {
    return this.orderLine.status.value === OrderStateStatus.SHIPPED;
  }

  public get isAllowedCancelReturning(): boolean {
    return this.orderLine.status.value === OrderStateStatus.RETURN_REQUESTED;
  }

  public get isAllowedDownloadReturnLabel(): boolean {
    return this.orderLine.status.value === OrderStateStatus.RETURN_REQUESTED;
  }

  public get isAllowedDownloadInvoicesDocs(): boolean {
    return (
      !this.isGetInvoiceFeatureEnabled &&
      [
        OrderStateStatus.SHIPPED,
        OrderStateStatus.RETURN_DECLINED,
        OrderStateStatus.RETURN_REQUESTED,
        OrderStateStatus.RETURN_ACCEPTED,
      ].includes(this.orderLine.status.value)
    );
  }

  public get isInvoiceDocumentsAttached(): boolean {
    const { invoices, creditNotes } = this.orderLine.documents;

    return Boolean(invoices.length || creditNotes.length);
  }

  public get isAllowedToContactSeller(): boolean {
    return ![
      OrderStateStatus.PAID,
      OrderStateStatus.WAITING_FOR_PAYMENT,
    ].includes(this.orderLine.status.value);
  }

  public get shouldShowContextMenu(): boolean {
    return (
      this.isAllowedOpenReturnInstructions ||
      this.isAllowedReturnProduct ||
      this.isAllowedCancelReturning ||
      this.isAllowedDownloadReturnLabel
    );
  }
}
